import React, { useEffect } from "react";

function RenderLatex({render}) {
  useEffect(() => {
    if (window.MathJax) {
      console.log("Rendering...");
      window.MathJax.typesetPromise();
    }
  }, [render]);
  return <></>;
}

export default React.memo(RenderLatex);
